import template from './unauthorized.html';
import controller from './unauthorized.controller';

let unauthorizedComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default unauthorizedComponent;



// WEBPACK FOOTER //
// ./client/pages/403/unauthorized.component.js